import React, { Suspense } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import routes from "./routes/routes.js";
import SpinnerNoPercet from "./components/common/SpinnerNoPercet";

function App() {

  return (
    <Router>
      <Suspense fallback={<SpinnerNoPercet />}>
        <Routes>
          {" "}
          {routes.map((route, index) => (
            <Route key={index} path={route.path} element={route.element} />
          ))}
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
